app.ui.fieldController.addParam(
	'formSearch',
	function(field, renderedFormControl){
		'use strict';

		var timer = {
			cancel : function(){}
		},
		isSearching = false,
		$searchBox,
		$searchBoxContent,
		fieldSettings,
		filterLogic;

		/*
			Name: initializeSearch
			Use: PRIVATE.initializeSearch()
			Args: none
			Description: Initializes the UI and the search box
		*/
		function initializeSearch(){
			$('#srch-{properties.id}'.compile(field)).on(
				'keyup',
				searchListener
			);

			$searchBox = $('#search-box-{properties.id}'.compile(field));
			$searchBoxContent = $('#search-box-{properties.id} .results'.compile(field));

			try {
				fieldSettings = renderedFormControl.pageConfig.myhdLogic.settings.fieldSettings[field.properties.id] || {};
				filterLogic = field.logic.filter(logicEntry => logicEntry.type === "filterBy");
			}
			catch(e){
				$searchBoxContent.html(`<div style="margin-top: 10px;padding: 10px;background-color: #ffdede;">An error occurred rendering search</div>`);
			}

			$('#search-box-{properties.id} .close-search'.compile(field)).on(
				'click',
				function(){
					$searchBox.css('display','none');
				}
			);
		}

		/*
			Name: searchListener
			Use: PRIVATE.searchListener()
			Args: none
			Description: Executes the searching
		*/
		function searchListener(){
			var srchStr = $('#srch-{properties.id}'.compile(field)).val().trim();

			timer.cancel();

			if(srchStr.trim()){
				timer = (function(){
					let data = {
						jurisdiction : $('#target_jurisdictionName').val(),
						searchStr : srchStr.trim(),
						form : field.properties.formID
					};
					isSearching = true;
					timer.cancel();
					$searchBoxContent.html('Searching...');
					$searchBox.css('display','block');

					if (filterLogic) {
						let filterFields = [],
							values = [],
							srcs = [],
							filterActions = [];

						filterLogic.forEach((filterLogicEntry) => {
							filterFields.push(filterLogicEntry.col);
							values.push(filterLogicEntry.value);
							srcs.push(filterLogicEntry.src);

							switch(filterLogicEntry.valueAction) {
								case '===':
									filterActions.push('EQUALS');
									break;
								case '!==':
									filterActions.push('NOT EQUAL');
									break;
								case 'indexOf':
									filterActions.push('IN');
									break;
								case 'notIndexOf':
									filterActions.push('NIN');
									break;
								case '>':
									filterActions.push('GT');
									break;
								case '>=':
									filterActions.push('GTE');
									break;
								case '<':
									filterActions.push('LT');
									break;
								case '<=':
									filterActions.push('LTE');
									break;
								default:
									filterActions.push('EQUALS');
									break;
							}
						});

						data.filterByCol = JSON.stringify(filterFields);
						data.filterByVal = JSON.stringify([values]);
						data.filterBySrc = JSON.stringify(srcs);
						data.filterByAct = JSON.stringify(filterActions);
					}

					app.ajax.request(
						{
							url : '/',
							contentType: "application/json",
							responseType : "json",
							success : handleSearchResults,
							error : function(){
								$searchBoxContent.html(`<div style="margin-top: 10px;padding: 10px;background-color: #ffdede;">An error occurred processing the search</div>`);
								isSearching = false;
							},
							args : {
								data,
								token : app.dataStore.get('session.token'),
								task : 'searchRecords'
							}
						}
					);
				}).After(750);
			}
			else {
				$searchBox.css('display','none');
			}
		}

		/*
			Name: handleSearchResults
			Use: PRIVATE.handleSearchResults()
			Args: res Object - Data response from the server
			Description: Handles the search response from the server and parses the results in the UI
		*/
		function handleSearchResults(res){
			var errMsg = `<div style="margin-top: 10px;padding: 10px;background-color: #ffdede;">Could not process search results</div>`,
				rowSelected,
				valueSelected;

			isSearching = false;

			if(!res.responseJson || (res.responseJson && res.responseJson.error)){
				$searchBoxContent.html(errMsg);
				return;
			}

			try {

				$searchBoxContent.html(
					`{[data]}
						<div class="w-row" style="margin-bottom: 10px;border-bottom: 1px solid #9999;">
							<div class="w-col w-col-10">
								{[fieldSettings.searchResultsLayout.columns]}
									<strong>{label}:</strong> {helpers.getRowOutput}
									<br />
								{[/fieldSettings.searchResultsLayout.columns]}
							</div>
							<div class="w-col w-col-2">
								<button type="button" role="button" data-row="{__i}" class="w-button select-button">{if:__parent.fieldSettings.isFormValidator}Verify{else}Select{/if}</button>
							</div>
						</div>
					{[/data]}`.compile(
						{
							data : res.responseJson.data,
							fieldSettings : fieldSettings,
							helpers : {
								getRowOutput : function(col){
									return col.out.compile(col.__parent);
								}
							}
						}
					)
				);

				$('#search-box-{properties.id} .results .select-button'.compile(field)).on(
					'click',
					function(){
						rowSelected = res.responseJson.data[this.getAttribute('data-row').val()];
						valueSelected = rowSelected[field.properties.id];

						if(!fieldSettings.isFormValidator){
							setSelectedValue(rowSelected, valueSelected);
						}
						else {
							$searchBoxContent.html(
								`<h5>Verify Information for:</h5>
								{[data]}
									<div class="w-row" style="margin-bottom: 10px;border-bottom: 1px solid #9999;">
										<div class="w-col w-col-12">
											{[fieldSettings.searchResultsLayout.columns]}
												<strong>{label}:</strong> {helpers.getRowOutput}
												<br />
											{[/fieldSettings.searchResultsLayout.columns]}
											<br />
											{[fieldSettings.formValidation.fields]}
												<div style="float: left;width: 20%;padding: 5px;">
													{properties.label}: <input type="text" id="verify-{properties.id}" class="form-control w-input" />
												</div>
											{[/fieldSettings.formValidation.fields]}
											<div style="float: left;width: 20%;padding: 5px;padding-top: 2%;">
												<button type="button" role="button" class="w-button do-verify">Verify Information</button>
											</div>
										</div>
									</div>
								{[/data]}`.compile(
									{
										data : [rowSelected],
										fieldSettings : fieldSettings,
										helpers : {
											getRowOutput : function(col){
												return col.out.compile(col.__parent);
											}
										}
									}
								)
							);

							$('#search-box-{properties.id} .results .do-verify'.compile(field)).on(
								'click',
								function(){
									var btn = this,
										data = {
											jurisdiction : $('#target_jurisdictionName').val(),
											form : field.properties.formID,
											fields : {}
										};

									btn.disabled = true;
									btn.innerHTML = 'Verifying...';

									fieldSettings.formValidation.fields.forEach(
										(field) => {
											data.fields[field.properties.id] = $('#verify-' + field.properties.id).val();
										}
									);

									app.ajax.request(
										{
											url : '/',
											contentType: "application/json",
											responseType : "json",
											success : function(res){
												btn.disabled = false;
												btn.innerHTML = 'Verify Information';

												if(!res.responseJson || (res.responseJson && res.responseJson.error)){
													alert('Invalid information');
												}
												else {
													setSelectedValue(rowSelected, valueSelected);
												}
											},
											error : function(){
												btn.disabled = false;
												btn.innerHTML = 'Verify Information';
												alert('Invalid information');
											},
											args : {
												data : data,
												token : app.dataStore.get('session.token'),
												task : 'validateRecord'
											}
										}
									);
								}
							);
						}
					}
				);
			}
			catch(e){
				$searchBoxContent.html(errMsg);
			}
		}

		/*
			Name: setSelectedValue
			Use: PRIVATE.setSelectedValue()
			Args: rowSelected Object - The row selected by the user
					valueSelected Object - The value (aka the primary key value) of the row/record the user selected
			Description: Handles setting the field values from the record the user selected
		*/
		function setSelectedValue(rowSelected, valueSelected){
			$('#' + field.properties.id).val(valueSelected);
			renderedFormControl.dataEntryApp.fieldValues[field.properties.id] = valueSelected;

			$searchBoxContent.html(
				`<h5>Selected:</h5>
				{[data]}
					<div class="w-row" style="margin-bottom: 10px;border-bottom: 1px solid #9999;">
						<div class="w-col w-col-10">
							{[fieldSettings.searchResultsLayout.columns]}
								<strong>{label}:</strong> {helpers.getRowOutput}
								<br />
							{[/fieldSettings.searchResultsLayout.columns]}
						</div>
						<div class="w-col w-col-2">
							<button type="button" role="button" data-row="{__i}" class="w-button remove-button">Remove</button>
						</div>
					</div>
				{[/data]}`.compile(
					{
						data : [rowSelected],
						fieldSettings : fieldSettings,
						helpers : {
							getRowOutput : function(col){
								return col.out.compile(col.__parent);
							}
						}
					}
				)
			);

			$('#search-box-{properties.id} .search-header'.compile(field)).css('display','none');
			$('#search-box-{properties.id} .results .remove-button'.compile(field)).on(
				'click',
				function(){
					$('#' + field.properties.id).val('');
					renderedFormControl.dataEntryApp.fieldValues[field.properties.id] = '';
					$('#search-box-{properties.id} .search-header'.compile(field)).css('display','');
					$searchBoxContent.html('');
					$searchBox.css('display','none');
				}
			);
		}

		initializeSearch.After(750);

		return `<label for="{properties.id}" class="translateable" style="{if:required}color: #AF0000;{/if}">{properties.label}</label>
		<input type="hidden" id="{properties.id}" v-model="{dataPath}" />
		<input type="text" class="form-control w-input" id="srch-{properties.id}" placeholder="Begin typing to search..." />
		<div style="padding: 15px;margin: 15px;border: 1px dotted #000;display: none;" id="search-box-{properties.id}">
		    <div class="w-row search-header">
			 	<div class="w-col w-col-10">
					<h5>Search Results</h5>
				</div>
			 	<div class="w-col w-col-2" style="text-align: right;">
					<span class="fa fa-remove close-search" aria-hidden="true" style="cursor: pointer;"></span>
				</div>
			</div>
		    <div style="overflow: auto;max-height: 450px;" class="results">Searching...</div>
		</div>
		`.compile(field);
	}
);
